// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
    background: var(--surface);
    border-radius: var(--radius-small);
    padding: 20px;
    position: relative;
    width: 80%;
    max-width: 600px;
}

/* Styles for the close icon */
.close-icon {
    position: absolute;
    top: 6px;
    right: 6px;
}

.custom-modal-content {
    padding: 6px;
    height: 100%;
    width: 100%;
}

.custom-outlined-button-submit {
    width: 200px;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/common-custom-modal.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".modal-content {\n    background: var(--surface);\n    border-radius: var(--radius-small);\n    padding: 20px;\n    position: relative;\n    width: 80%;\n    max-width: 600px;\n}\n\n/* Styles for the close icon */\n.close-icon {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n}\n\n.custom-modal-content {\n    padding: 6px;\n    height: 100%;\n    width: 100%;\n}\n\n.custom-outlined-button-submit {\n    width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
